import { createLogic } from 'redux-logic';
import moment from 'moment';
import {
  FETCH_USER_DATA_PENDING,
  ENABLE_ORG_MANAGEMENT
} from '../constants';
import { fetchUserDataSuccess, fetchUserDataError, setBannerState, getLinkedOrganizationsPending } from '../actions/AppActions';
import intl from '../actions/lang/en.json';

const formatDate = date =>
  date
    ? moment.utc(date).utcOffset('+0100').format('MM/DD/YYYY')
    : undefined;

const cleanPhoneCategory = (phone, acceptedPhoneTypes) => ({
  ...phone,
  category: phone.category && acceptedPhoneTypes.includes(phone.category)
    ? phone.category
    : '',
});

export const fetchUserDataLogic = createLogic({
  type: FETCH_USER_DATA_PENDING,
  latest: true,
  processOptions: {
    dispatchMultiple: true
  },
  process({ httpClient }, dispatch, done) {
    return httpClient(dispatch).get('/profile')
      .then(res => {
        const person = res.data.person;
        const username = res.data.emails?.find(email => email.isUsername)?.emailAddress;
        const user = {
          ...person,
          initials: person?.firstName?.length && person.firstName.charAt(0),
          fullName: person?.firstName && person?.lastName && `${person.firstName} ${person.lastName}`,
          initialsColor: '#E6B952',
          phones: res.data.phones
            ? res.data.phones.map(phone => cleanPhoneCategory(phone, ['HOME', 'MOBILE', 'WORK']))
            : [],
          emailAddress: username || '[PLEASE UPDATE YOUR EMAIL ADDRESS]',
          addresses: res.data.addresses || [],
          birthDate: formatDate(person.birthDate),
        };
        dispatch(fetchUserDataSuccess(user));
        if (ENABLE_ORG_MANAGEMENT) dispatch(getLinkedOrganizationsPending(user.id));
      })
      .catch(err => {
        const message = intl.Errors.Profile.Get_Personal_Info_Error;
        const bannerState = {
          data: { type: 'error', message }
        };
        dispatch(setBannerState(bannerState));
        dispatch(fetchUserDataError(err));
      })
      .finally(() => done());
  }
});

export default fetchUserDataLogic;
